import React from 'react';
import { Button, InputGroup, Modal, Alert, Table, FormGroup, Radio, Row, Col, DropdownButton, MenuItem, ControlLabel, FormControl } from 'react-bootstrap';

const LoadingModal = ({
	show_loading_modal
}) => (
		<div>
			<Modal show={show_loading_modal} className="modal-loading">
				<Modal.Header>
					<Modal.Title>
						<Col style={{ marginBottom: "10px" }}> Loading... </Col>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<center>
						<img src='/assets/img/small-loader.gif'/>
					</center>
				</Modal.Body>

				<Modal.Footer>
			
				</Modal.Footer>
			</Modal>
		</div>
	);

export default LoadingModal;


// WEBPACK FOOTER //
// ./src/client/views/global/LoadingModal.js